:global(#root) {
  .button {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    background-color: var(--pm-blue);
    color: var(--pm-text-filled-button);
    border: 1px solid;
    border-radius: 8px;
    font-size: 17px;
    font-weight: 600;
    padding: 8px 20px;
    display: flex;
    width: 100%;
    justify-content: center;
    border-color: var(--pm-blue);
    user-select: none;
    letter-spacing: 0;
    text-transform: none;
    height: auto;
    margin-bottom: 10px;
    height: 48px;
    align-items: center;
    cursor: pointer;
    transition:
      background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

    /* Hover */
    &:hover {
      background-color: var(--pm-blue-lighter) !important;
    }

    /* Hidden */
    &.hidden {
      display: none;
    }

    /* Disabled */
    &[disabled] {
      background-color: var(--pm-grey8);
      border-color: var(--pm-grey8);
      pointer-events: none;
    }

    /* Alternate */
    &.alternate,
    &.social {
      background-color: transparent;

      /* Alternate - Hover */
      &:hover {
        background-color: rgba(54, 135, 255, 0.07) !important;
      }
      /* Alternate - Disabled */
      &[disabled] {
        color: var(--pm-grey8);
        border: 1px solid var(--pm-grey8);
        background-color: white;
        pointer-events: none;
      }
    }
    &.alternate {
      color: var(--pm-blue);
    }
    &.social {
      color: var(--pm-black);
      border-color: var(--pm-grey7);
    }
    .logo {
      position: absolute;
      left: 10;
    }
  }
}

:global(.theme-dark1) :global(#root) {
  .button:not(.alternate):not(.social) {
    color: var(--pm-text-filled-button) !important;
  }
}

:global(#root) {
  :global(.dark) {
    /* Dark - Button */
    .button:not(.alternate):not(.social) {
      color: var(--pm-text-filled-button) !important;
    }

    .button {
      /* Dark - Button - Alternate */
      &.alternate {
        color: var(--pm-blue-lighter) !important;
        border-color: var(--pm-blue-lighter) !important;

        /* Dark - Button - Alternate - Disabled */
        &[disabled] {
          background: transparent !important;
          border-color: var(--pm-grey2) !important;
          color: var(--pm-grey4) !important;
        }
      }
      &.social {
        color: var(--pm-white);
        border-color: var(--pm-grey3);

        /* Dark - Button - Social - Disabled */
        &[disabled] {
          background: transparent !important;
          border-color: var(--pm-grey2) !important;
          color: var(--pm-grey4) !important;
        }
      }
      /* Dark - Button - Disabled */
      &[disabled] {
        background-color: var(--pm-grey2);
        border-color: var(--pm-grey2);
        color: var(--pm-grey6);
      }
    }
  }
}

:global(.dark) {
  .buttonDialogClose {
    path {
      fill: var(--pm-white);
    }
  }
  :global(.dark) {
    .accountButton {
      .accountAvatar[style*="avatar_default"] {
        filter: none !important;
      }
    }
  }
  .disabledLink {
    pointer-events: none;
  }
  .buttonLink {
    text-decoration: none;
    width: 100%;
  }
}
